import { observer } from 'mobx-react';
import selectOldMeetingMessageOption from '../actions/selectOldMeetingMessageOption';
import * as React from 'react';
import { OptionsCheckbox } from 'owa-options-controls';
import strings from 'owa-strings/owa-options-strings';
import getOldMeetingMessgeOption from '../selectors/getOldMeetingMessageOption';

/**
 * Specifies the option to toggle the remove old meeting message options under the invitation settings
 */

@observer
export default class DeleteOldMeetingMessageOption extends React.Component<{}, {}> {
    render() {
        let oldMeetingMessageOption = getOldMeetingMessgeOption();

        return (
            <OptionsCheckbox
                label={strings.options_delete_invitations_and_responses}
                checked={oldMeetingMessageOption}
                onChange={this.onOldMeetingMessageSettingChange}
            />
        );
    }

    private onOldMeetingMessageSettingChange = (
        ev?: React.FormEvent<HTMLElement | HTMLInputElement>,
        checked?: boolean
    ) => {
        selectOldMeetingMessageOption(checked);
    };
}
